import React from 'react'

import './errors.css'

const Errors = (props) => (
  <div className='title'>
    404 - This page cannot be found.
  </div>
)

Errors.propTypes = {
}

export default Errors



// WEBPACK FOOTER //
// ./src/components/Errors/index.js